import { TFunction } from "i18next";

const dateRangeTitles = (t: TFunction) => [
  t("dateRange.startDate"),
  t("dateRange.endDate")
];

const tableHeaders = (t: TFunction) => [
  {
    label: t("billingHistory.billingPeriod")
  },
  {
    label: t("billingHistory.value")
  }
];

const filtersMobileInputs = (t: TFunction) => [
  {
    id: "dates",
    size: {
      xs: 12,
      sm: 6
    },
    component: "dateRange",
    props: {
      titles: dateRangeTitles(t)
    }
  }
];

const filtersDesktopInputs = (t: TFunction) => [
  {
    id: "dates",
    size: {
      sm: 4,
      md: 4,
      lg: 3
    },
    component: "dateRange",
    props: {
      titles: dateRangeTitles(t)
    }
  }
];

export { tableHeaders, filtersDesktopInputs, filtersMobileInputs };
